<script>
  import { Input, Popover } from '@sveltestrap/sveltestrap';

  import { generateUUID } from '@common/utils/strings';

  import { propertyRanges } from './utils';

  /** @type {number} */
  export let max = 100;

  /** @type {number} */
  export let min = 0;

  /** @type {string} */
  export let placement = 'bottom';

  /** @type {string} */
  export let property;

  /** @type {string} */
  export let size = 'sm';

  /** @type {number} */
  export let step = 1;

  /** @type {string} */
  export let unit = '';

  /** @type {string} */
  export let value;

  /** @type {(string): void} */
  export let onChange = (value) => {};

  const id = `number-range-${generateUUID()}`;

  $: onChange(value);

  $: {
    const config = propertyRanges[property] || propertyRanges.defaults;
    const unitConfig = config.units?.[unit] || config.defaults;

    min = unitConfig.min;
    max = unitConfig.max;
    step = unitConfig.step;
  }

  let numberValue = 0;

  // Unwraps the string value with units for the range input:
  $: if (value) {
    const numberMatch = value.match(/^-?\d*\.?\d+/);
    const unitMatch = value.match(/[a-zA-Z%]+/);

    const n = numberMatch ? parseFloat(numberMatch[0]) : 0;

    if (n > max) {
      max = Math.ceil(n);
    } else if (n < min) {
      min = Math.floor(n);
    }

    numberValue = n;
    unit = unitMatch && numberMatch ? unitMatch[0] : '';
  } else {
    unit = '';
  }

  $: {
    onChange(numberValue !== undefined ? `${numberValue}${unit}` : '');
  }
</script>

<Input {min} {max} {id} bsSize={size} {...$$restProps} bind:value />

<Popover {placement} target={id} hideOnOutsideClick class="shadow">
  <div class="d-flex align-items-center" class:mb-2={$$slots.default}>
    {min}
    <Input type="range" class="mx-1" {min} {max} {step} bind:value={numberValue} />
    {max}{unit}
  </div>
  <slot />
</Popover>
